import { render, staticRenderFns } from "./Images.vue?vue&type=template&id=bfbc5e0c&scoped=true&"
import script from "./Images.vue?vue&type=script&lang=js&"
export * from "./Images.vue?vue&type=script&lang=js&"
import style0 from "./Images.vue?vue&type=style&index=0&id=bfbc5e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbc5e0c",
  null
  
)

export default component.exports